export default {
    regSeason: {
        standings: [
            {manager: 'Davis', wins: 9, losses: 4, pf: 1897, champ: true},
            {manager: 'Tommy', wins: 8, losses: 5, pf: 1888},
            {manager: 'Taylor', wins: 8, losses: 5, pf: 1848},
            {manager: 'Dan', wins: 8, losses: 5, pf: 1793},
            {manager: 'Scott', wins: 8, losses: 5, pf: 1709},
            {manager: 'Tench', wins: 7, losses: 6, pf: 1674},
            {manager: 'Steve', wins: 7, losses: 6, pf: 1650},
            {manager: 'Zane', wins: 7, losses: 6, pf: 1560},
            {manager: 'Mike', wins: 7, losses: 6, pf: 1493},
            {manager: 'Conor', wins: 6, losses: 7, pf: 1603},
            {manager: 'Aidan', wins: 2, losses: 11, pf: 1335, sacko: true},
            {manager: 'Kieffer', wins: 1, losses: 12, pf: 1356}
        ]
    },
    playoffs: {
        teamData: {
            Davis: {
                seed: 1
            },
            Tommy: {
                seed: 2
            },
            Taylor: {
                seed: 3
            },
            Dan: {
                seed: 4
            },
            Scott: {
                seed: 5
            },
            Tench: {
                seed: 6
            }
        },
        gameData: [
            {
                name: 'Caleci-Fairlawn-Kennedy Championship Game',
                games: [
                    {
                        Davis: 147.4,
                        Taylor: 117.2
                    }
                ],
                props: {
                    winnerIcon: 'trophyGold bi bi-trophy-fill',
                    loserIcon: 'trophySilver bi bi-trophy-fill',
                }
            },
            {
                name: 'Semifinals',
                games: [
                    {
                        Davis: 174.2,
                        Scott: 155.4
                    },
                    {
                        Taylor: 148.2,
                        Tommy: 124.7
                    }
                ]
            },
            {
                name: 'Wildcard',
                games: [
                    {
                        Dan: 142.5,
                        Scott: 151.8
                    },
                    {
                        Taylor: 121.4,
                        Tench: 67.9
                    }
                ]
            },
        ]
    },
    draft: {
        isAuction: true,
        order: [],
        picks: [
            {manager: 'Zane', pick: 'Philip Rivers', cost: 2},
            {manager: 'Zane', pick: 'Lamar Miller', cost: 28},
            {manager: 'Zane', pick: 'C.J. Anderson', cost: 7},
            {manager: 'Zane', pick: 'Jordy Nelson', cost: 50},
            {manager: 'Zane', pick: 'Mike Evans', cost: 55},
            {manager: 'Zane', pick: 'Cameron Brate', cost: 1},
            {manager: 'Zane', pick: 'Alshon Jeffery', cost: 31},
            {manager: 'Zane', pick: 'Theo Riddick', cost: 9},
            {manager: 'Zane', pick: 'Patriots D/ST', cost: 2},
            {manager: 'Zane', pick: 'Blair Walsh', cost: 1},
            {manager: 'Zane', pick: 'Ameer Abdullah', cost: 11},
            {manager: 'Zane', pick: 'Eric Decker', cost: 5},
            {manager: 'Zane', pick: 'Marvin Jones', cost: 2},
            {manager: 'Zane', pick: 'Latavius Murray', cost: 3},
            {manager: 'Zane', pick: 'James Conner', cost: 6},
            {manager: 'Zane', pick: 'Jamaal Charles', cost: 1},
            {manager: 'Zane', pick: 'Nelson Agholor', cost: 1},
            {manager: 'Conor', pick: 'Drew Brees', cost: 7},
            {manager: 'Conor', pick: 'LeSean McCoy', cost: 52},
            {manager: 'Conor', pick: 'Leonard Fournette', cost: 46},
            {manager: 'Conor', pick: 'Sammy Watkins', cost: 18},
            {manager: 'Conor', pick: 'Stefon Diggs', cost: 17},
            {manager: 'Conor', pick: 'Hunter Henry', cost: 11},
            {manager: 'Conor', pick: 'Joe Mixon', cost: 19},
            {manager: 'Conor', pick: 'Carlos Hyde', cost: 22},
            {manager: 'Conor', pick: 'Eagles D/ST', cost: 1},
            {manager: 'Conor', pick: 'Cairo Santos', cost: 2},
            {manager: 'Conor', pick: 'Wendell Smallwood', cost: 1},
            {manager: 'Conor', pick: 'Ben Roethlisberger', cost: 4},
            {manager: 'Conor', pick: 'Ted Ginn Jr.', cost: 2},
            {manager: 'Conor', pick: 'Rex Burkhead', cost: 3},
            {manager: 'Conor', pick: 'John Brown', cost: 2},
            {manager: 'Conor', pick: 'D\'Onta Foreman', cost: 3},
            {manager: 'Conor', pick: 'O.J. Howard', cost: 3},
            {manager: 'Tommy', pick: 'Tom Brady', cost: 26},
            {manager: 'Tommy', pick: 'LeGarrette Blount', cost: 3},
            {manager: 'Tommy', pick: 'Matt Forte', cost: 4},
            {manager: 'Tommy', pick: 'Brandin Cooks', cost: 54},
            {manager: 'Tommy', pick: 'Pierre Garcon', cost: 10},
            {manager: 'Tommy', pick: 'Rob Gronkowski', cost: 39},
            {manager: 'Tommy', pick: 'Greg Olsen', cost: 18},
            {manager: 'Tommy', pick: 'Willie Snead', cost: 13},
            {manager: 'Tommy', pick: 'Jaguars D/ST', cost: 1},
            {manager: 'Tommy', pick: 'Matt Prater', cost: 1},
            {manager: 'Tommy', pick: 'Russell Wilson', cost: 3},
            {manager: 'Tommy', pick: 'DeSean Jackson', cost: 17},
            {manager: 'Tommy', pick: 'Adam Thielen', cost: 7},
            {manager: 'Tommy', pick: 'Jordan Matthews', cost: 8},
            {manager: 'Tommy', pick: 'Jonathan Stewart', cost: 4},
            {manager: 'Tommy', pick: 'Chris Thompson', cost: 1},
            {manager: 'Tommy', pick: 'Jacquizz Rodgers', cost: 3},
            {manager: 'Kieffer', pick: 'Matt Ryan', cost: 8},
            {manager: 'Kieffer', pick: 'Melvin Gordon', cost: 45},
            {manager: 'Kieffer', pick: 'Terrance West', cost: 4},
            {manager: 'Kieffer', pick: 'Julio Jones', cost: 64},
            {manager: 'Kieffer', pick: 'Jamison Crowder', cost: 25},
            {manager: 'Kieffer', pick: 'Zach Ertz', cost: 9},
            {manager: 'Kieffer', pick: 'Dalvin Cook', cost: 27},
            {manager: 'Kieffer', pick: 'Jeremy Maclin', cost: 11},
            {manager: 'Kieffer', pick: 'Texans D/ST', cost: 3},
            {manager: 'Kieffer', pick: 'Justin Tucker', cost: 2},
            {manager: 'Kieffer', pick: 'Tyrell Williams', cost: 11},
            {manager: 'Kieffer', pick: 'Sterling Shepard', cost: 1},
            {manager: 'Kieffer', pick: 'Samaje Perine', cost: 1},
            {manager: 'Kieffer', pick: 'Joe Williams', cost: 1},
            {manager: 'Kieffer', pick: 'Jamaal Williams', cost: 1},
            {manager: 'Kieffer', pick: 'Jeremy Hill', cost: 1},
            {manager: 'Kieffer', pick: 'David Njoku', cost: 1},
            {manager: 'Davis', pick: 'Cam Newton', cost: 5},
            {manager: 'Davis', pick: 'Ezekiel Elliott', cost: 58},
            {manager: 'Davis', pick: 'Ty Montgomery', cost: 21},
            {manager: 'Davis', pick: 'Odell Beckham Jr.', cost: 64},
            {manager: 'Davis', pick: 'Michael Crabtree', cost: 16},
            {manager: 'Davis', pick: 'Austin Hooper', cost: 3},
            {manager: 'Davis', pick: 'Kelvin Benjamin', cost: 16},
            {manager: 'Davis', pick: 'Mike Gillislee', cost: 6},
            {manager: 'Davis', pick: 'Panthers D/ST', cost: 2},
            {manager: 'Davis', pick: 'Harrison Butker', cost: 1},
            {manager: 'Davis', pick: 'Darren McFadden', cost: 7},
            {manager: 'Davis', pick: 'Eli Manning', cost: 3},
            {manager: 'Davis', pick: 'Derrick Henry', cost: 8},
            {manager: 'Davis', pick: 'Jack Doyle', cost: 1},
            {manager: 'Davis', pick: 'Robert Woods', cost: 1},
            {manager: 'Davis', pick: 'Evan Engram', cost: 2},
            {manager: 'Davis', pick: 'Devin Funchess', cost: 1},
            {manager: 'Aidan', pick: 'Kirk Cousins', cost: 4},
            {manager: 'Aidan', pick: 'David Johnson', cost: 69},
            {manager: 'Aidan', pick: 'Spencer Ware', cost: 6},
            {manager: 'Aidan', pick: 'Demaryius Thomas', cost: 30},
            {manager: 'Aidan', pick: 'Golden Tate', cost: 19},
            {manager: 'Aidan', pick: 'Travis Kelce', cost: 17},
            {manager: 'Aidan', pick: 'Jordan Reed', cost: 15},
            {manager: 'Aidan', pick: 'Frank Gore', cost: 8},
            {manager: 'Aidan', pick: 'Broncos D/ST', cost: 2},
            {manager: 'Aidan', pick: 'Adam Vinatieri', cost: 1},
            {manager: 'Aidan', pick: 'Donte Moncrief', cost: 8},
            {manager: 'Aidan', pick: 'Cameron Meredith', cost: 5},
            {manager: 'Aidan', pick: 'Mike Wallace', cost: 4},
            {manager: 'Aidan', pick: 'Randall Cobb', cost: 12},
            {manager: 'Aidan', pick: 'Tevin Coleman', cost: 6},
            {manager: 'Aidan', pick: 'Matthew Stafford', cost: 2},
            {manager: 'Aidan', pick: 'Mason Crosby', cost: 1},
            {manager: 'Scott', pick: 'Aaron Rodgers', cost: 26},
            {manager: 'Scott', pick: 'Mark Ingram', cost: 10},
            {manager: 'Scott', pick: 'Danny Woodhead', cost: 14},
            {manager: 'Scott', pick: 'Michael Thomas', cost: 50},
            {manager: 'Scott', pick: 'Keenan Allen', cost: 31},
            {manager: 'Scott', pick: 'Delanie Walker', cost: 6},
            {manager: 'Scott', pick: 'Emmanuel Sanders', cost: 19},
            {manager: 'Scott', pick: 'Jarvis Landry', cost: 20},
            {manager: 'Scott', pick: 'Cardinals D/ST', cost: 2},
            {manager: 'Scott', pick: 'Matt Bryant', cost: 2},
            {manager: 'Scott', pick: 'Eddie Lacy', cost: 5},
            {manager: 'Scott', pick: 'C.J. Prosise', cost: 3},
            {manager: 'Scott', pick: 'Thomas Rawls', cost: 1},
            {manager: 'Scott', pick: 'Mike Williams', cost: 7},
            {manager: 'Scott', pick: 'Shane Vereen', cost: 1},
            {manager: 'Scott', pick: 'John Ross', cost: 7},
            {manager: 'Scott', pick: 'Dion Lewis', cost: 1},
            {manager: 'Steve', pick: 'Marcus Mariota', cost: 6},
            {manager: 'Steve', pick: 'Jay Ajayi', cost: 43},
            {manager: 'Steve', pick: 'Adrian Peterson', cost: 6},
            {manager: 'Steve', pick: 'Doug Baldwin', cost: 34},
            {manager: 'Steve', pick: 'Terrelle Pryor Sr.', cost: 34},
            {manager: 'Steve', pick: 'Martellus Bennett', cost: 8},
            {manager: 'Steve', pick: 'Kyle Rudolph', cost: 10},
            {manager: 'Steve', pick: 'Corey Coleman', cost: 5},
            {manager: 'Steve', pick: 'Giants D/ST', cost: 2},
            {manager: 'Steve', pick: 'Dustin Hopkins', cost: 1},
            {manager: 'Steve', pick: 'Dak Prescott', cost: 4},
            {manager: 'Steve', pick: 'James White', cost: 5},
            {manager: 'Steve', pick: 'Corey Davis', cost: 12},
            {manager: 'Steve', pick: 'Alvin Kamara', cost: 4},
            {manager: 'Steve', pick: 'Chris Hogan', cost: 5},
            {manager: 'Steve', pick: 'Cooper Kupp', cost: 3},
            {manager: 'Steve', pick: 'Kenny Stills', cost: 33},
            {manager: 'Mike', pick: 'Jameis Winston', cost: 5},
            {manager: 'Mike', pick: 'Le\'Veon Bell', cost: 68},
            {manager: 'Mike', pick: 'Jordan Howard', cost: 34},
            {manager: 'Mike', pick: 'T.Y. Hilton', cost: 44},
            {manager: 'Mike', pick: 'DeAndre Hopkins', cost: 36},
            {manager: 'Mike', pick: 'Eric Ebron', cost: 1},
            {manager: 'Mike', pick: 'Kevin White', cost: 5},
            {manager: 'Mike', pick: 'Doug Martin', cost: 8},
            {manager: 'Mike', pick: 'Chiefs D/ST', cost: 1},
            {manager: 'Mike', pick: 'Dan Bailey', cost: 1},
            {manager: 'Mike', pick: 'Torrey Smith', cost: 1},
            {manager: 'Mike', pick: 'Will Fuller V', cost: 1},
            {manager: 'Mike', pick: 'Kenny Golladay', cost: 2},
            {manager: 'Mike', pick: 'Curtis Samuel', cost: 3},
            {manager: 'Mike', pick: 'Malcolm Mitchell', cost: 2},
            {manager: 'Mike', pick: 'Adam Shaheen', cost: 1},
            {manager: 'Mike', pick: 'Devontae Booker', cost: 1},
            {manager: 'Tench', pick: 'Derek Carr', cost: 9},
            {manager: 'Tench', pick: 'Devonta Freeman', cost: 41},
            {manager: 'Tench', pick: 'Isaiah Crowell', cost: 22},
            {manager: 'Tench', pick: 'Martavis Bryant', cost: 15},
            {manager: 'Tench', pick: 'Larry Fitzgerald', cost: 13},
            {manager: 'Tench', pick: 'Tyler Eifert', cost: 6},
            {manager: 'Tench', pick: 'Amari Cooper', cost: 45},
            {manager: 'Tench', pick: 'Davante Adams', cost: 21},
            {manager: 'Tench', pick: 'Vikings D/ST', cost: 2},
            {manager: 'Tench', pick: 'Wil Lutz', cost: 1},
            {manager: 'Tench', pick: 'Tyreek Hill', cost: 23},
            {manager: 'Tench', pick: 'Robert Kelley', cost: 9},
            {manager: 'Tench', pick: 'Kenny Britt', cost: 3},
            {manager: 'Tench', pick: 'Marqise Lee', cost: 1},
            {manager: 'Tench', pick: 'Andy Dalton', cost: 1},
            {manager: 'Tench', pick: 'Jason Witten', cost: 1},
            {manager: 'Tench', pick: 'Tyler Lockett', cost: 1},
            {manager: 'Dan', pick: 'Andrew Luck', cost: 3},
            {manager: 'Dan', pick: 'Todd Gurley', cost: 46},
            {manager: 'Dan', pick: 'Marshawn Lynch', cost: 25},
            {manager: 'Dan', pick: 'A.J. Green', cost: 56},
            {manager: 'Dan', pick: 'Dez Bryant', cost: 41},
            {manager: 'Dan', pick: 'Jerell Adams', cost: 2},
            {manager: 'Dan', pick: 'Brandon Marshall', cost: 11},
            {manager: 'Dan', pick: 'Duke Johnson Jr.', cost: 7},
            {manager: 'Dan', pick: 'Seahawks D/ST', cost: 2},
            {manager: 'Dan', pick: 'Roberto Aguayo', cost: 3},
            {manager: 'Dan', pick: 'Paul Perkins', cost: 4},
            {manager: 'Dan', pick: 'Julian Edelman', cost: 2},
            {manager: 'Dan', pick: 'Rishard Matthews', cost: 2},
            {manager: 'Dan', pick: 'Carson Wentz', cost: 3},
            {manager: 'Dan', pick: 'Darren Sproles', cost: 3},
            {manager: 'Dan', pick: 'Giovani Bernard', cost: 2},
            {manager: 'Dan', pick: 'Josh Doctson', cost: 3},
            {manager: 'Taylor', pick: 'Tyrod Taylor', cost: 1},
            {manager: 'Taylor', pick: 'Christian McCaffrey', cost: 28},
            {manager: 'Taylor', pick: 'DeMarco Murray', cost: 38},
            {manager: 'Taylor', pick: 'Antonio Brown', cost: 65},
            {manager: 'Taylor', pick: 'Allen Robinson', cost: 10},
            {manager: 'Taylor', pick: 'Jimmy Graham', cost: 9},
            {manager: 'Taylor', pick: 'Bilal Powell', cost: 14},
            {manager: 'Taylor', pick: 'Kareem Hunt', cost: 24},
            {manager: 'Taylor', pick: 'Bengals D/ST', cost: 1},
            {manager: 'Taylor', pick: 'Steve Gostkowski', cost: 1},
            {manager: 'Taylor', pick: 'DeVante Parker', cost: 15},
            {manager: 'Taylor', pick: 'Zay Jones', cost: 4},
            {manager: 'Taylor', pick: 'Danny Amendola', cost: 1},
            {manager: 'Taylor', pick: 'Charles Sims', cost: 1},
            {manager: 'Taylor', pick: 'DeAndre Washington', cost: 1},
            {manager: 'Taylor', pick: 'Cole Beasley', cost: 1},
            {manager: 'Taylor', pick: 'Jalen Richard', cost: 1},
        ]
    }
}